<template lang="pug">
  a.khabib(href="https://redirect.appmetrica.yandex.com/serve/749858812185328814" target="_blank")
    img(src="~@/assets/img/header/khabib-promo.png")
</template>

<script>

export default {
  name: 'HeaderKhabib'
}
</script>
